
import Vue from 'vue'



window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'Json'
Vue.prototype.$http = window.axios



import App from './App.vue'

window.jsPDF = require('jspdf');
window.PulseLoader = require('vue-spinner/src/PulseLoader.vue');

// Vue.component('pulse-loader', require(PulseLoader));
Vue.component('pulse-loader', PulseLoader);




Vue.config.productionTip = false


new Vue({
  render: h => h(App)
}).$mount('#app')

// const app = new Vue({
//     el: '#app'
//
// });
